<template>
  <div>
    <order-modal v-show="isModalVisible" @close="closeModal"/>
    <loading :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
      :color="color"
      :loader="loader">
    </loading>
    <h3 class="page-header">Orders/Invoice Report</h3>
    <div class="report-wrapper">
      <div class="row report-inputs">
        <div ref='partner_select' class="col-md-3">
          <multiselect
            v-model="np_selected"
            :options="nationalPartners"
            :multiple="true"
            pen-direction="bottom"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Choose National Partner(s)"
            label="NAME"
            track-by="CODE"
            select-label="Click to select"
            deselect-label="Click to remove"
            :preselect-first="false"
            :taggable="true"
            @close="getRestaurants()">
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="np_selected.length" @mousedown.prevent.stop="clearAllNP()">❌</div>
            </template>
          </multiselect>
          <label class="form_error" v-show="isNPInvalid">Must select at least one value</label>
        </div>
        <div ref='selected' class="col-md-3">
          <multiselect
            v-model="selected"
            :options="restaurants"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :searchable="true"
            :allow-empty="true"
            :preserve-search="true"
            placeholder="Choose Restaurant(s)"
            label="storeDisplay"
            track-by="externalId"
            select-label="Click to select"
            deselect-label="Click to remove"
            :preselect-first="false">
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="selected.length" @mousedown.prevent.stop="clearAllRestos()">❌</div>
            </template>
          </multiselect>
          <label class="form_error" v-show="isRestInvalid">Must select at least one value</label>
        </div>

        <div class="col-md-2">
          <datepicker v-model="start_date" placeholder="Start Date"></datepicker>
        </div>
        <div class="col-md-2">
          <datepicker v-model="end_date" placeholder="End Date"></datepicker>
        </div>
        <div class="col-md-2">
          <button id="btn" class="btn btn-primary btn-fill" :disabled="btnDissabled == 1" v-on:click="getInvoiceReport">Generate Report</button>
        </div>
        <div v-show="isSupport" class="row report-inputs">
          <div class="col-md-3"></div>
          <div class="col-md-3"></div>
          <div class="col-md-2">
            <input type="checkbox" v-model="include_cancelled">
            <label class="">Include Cancelled Orders</label>
          </div>
          <div class="col-md-3">
            <input type="checkbox" v-model="show_cancelled_only">
            <label class="">Show Cancelled Orders Only</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div v-if="alert" class="header">
              <slot name="header">
                <h4 class="title">{{alert}}</h4>
              </slot>
            </div>
            <div class="downloads" ref="downloads" v-if="seen">
              <button v-on:click="exportTableToCSV('invoice_report.csv')" class="btn btn-default"><i class="ti-layout"></i> CSV</button>
            </div>

            <!-- <div v-if="seen" class="header">
              <slot name="header">
                <h4 class="title total-header">Overall Total</h4>
              </slot>
            </div> -->
            <div v-if="seen" class="content table-responsive table-full-width">
              <table class="table table-hover totals-table">
                <thead>
                  <tr>
                    <th v-for="total_heading in total_headings" v-bind:class="total_heading">{{total_heading}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="totals.NET_PAY">
                    <td>{{totals.TOTAL_ORDERS}}</td>
                    <td>{{totals.SUB_TOTAL | currency}}</td>
                    <td>{{totals.COMMISSION_PCT}}%</td>
                    <td class="red">{{totals.DL_COMMISSION | currency}}</td>
                    <td>{{totals.FOOD_PAYMENT | currency}}</td>
                    <td>{{totals.TAX_PAYMENT | currency}}</td>
                    <td v-if="totals.SHOW_ADJUSTMENTS && totals.ADJUSTMENTS_COLOR == 'red'" class="red">{{totals.ADJUSTMENTS | currency}}</td>
                    <td v-else-if="totals.SHOW_ADJUSTMENTS && totals.ADJUSTMENTS_COLOR == 'black'">{{totals.ADJUSTMENTS | currency}}</td>
                    <td>{{totals.NET_PAY | currency}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="seen" v-for="invoice in table.data" class="content table-responsive table-full-width">
              <div class="header">
                <slot name="header">
                  <template v-for="(item, key, index) in invoice.slice(0,1)">
                    <h4 class="title">{{table.title}} For {{item.RESTAURANTNAME}}</h4>
                    <span class="rest_address">{{item.ADDRESS1 + ', ' + item.CITY + ', ' + item.STATE + ', ' + item.RZIP}}</span>
                  </template>
                </slot>
              </div>
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th v-for="column in table.columns">{{column}}</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <template v-for="restaurant in table.data"> -->
                    <tr v-for="(item, key, index) in invoice">
                      <td>{{item.STORE_NUMBER}}</td>
                      <td>{{item.CITY}}</td>
                      <td v-if="!isNaN(parseFloat(item.OID)) && !/[^0-9]/.test(item.OID)" id="show-modal" @click.stop="showOrderModal(item.OID, item.EXTERNAL_BRAND, item.EXTERNAL_ID, item.CLIENT)">{{item.OID}}</td>
                      <td v-else>{{item.OID}}</td>
                      <td><a target="_blank" v-bind:href="item.DSP_URL">{{item.DSP_NAME}}</a></td>
                      <!-- <td v-if="item.RESTAURANTPAID == 1">Yes {{item.RESTAURANTPAID}}</td>
                      <td v-else-if="item.RESTAURANTPAID == 0">No</td>
                      <td v-else></td> -->
                      <!-- <td :key="item.TYPE">{{item.TYPE}}</td> -->
                      <td>{{item.DELIVEREDDATE}}</td>
                      <td>{{item.CHECKOUTMETHOD}}</td>
                      <td v-if="item.SHIFT">{{item.SHIFT}}</td>
                      <td v-else>Total</td>
                      <td>{{item.SUBTOTAL | currency}}</td>
                      <td>{{item.COMMISSION_PCT}}%</td>
                      <td class="red">{{item.DL_COMMISSION | currency}}</td>
                      <td>{{item.FOODPAYMENT | currency}}</td>
                      <td>{{item.TAX | currency}}</td>
                      <td v-if="item.SHOW_ADJUSTMENTS && item.ADJUSTTYPE == 'CREDIT'" class="black">{{item.ADJUSTAMOUNT | currency}}</td>
                      <td v-else-if="item.SHOW_ADJUSTMENTS && item.ADJUSTTYPE == 'CHARGE'" class="red">{{item.ADJUSTAMOUNT | currency}}</td>
                      <td v-else-if="item.SHOW_ADJUSTMENTS" class="black">{{item.ADJUSTAMOUNT | currency}}</td>
                      <!-- <td v-else>{{item.ADJUSTAMOUNT | currency}}</td> -->
                      <td>{{item.NET_PAY | currency}}</td>
                    </tr>
                  <!-- </template> -->
                </tbody>
              </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import {API} from 'src/api'
  import moment from 'moment'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  if(localStorage.userInfo) {
    var userInfo = JSON.parse(localStorage.userInfo)
  }
  export default {
    components: {
      Loading
    },
    data () {
      return {
        start_date: moment().subtract(1, 'days').toString(),
        end_date: moment().toString(),
        alert: 'Please select your criteria above.',
        table: {
          title: '',
          columns: [],
          data: [],
          extid: []
        },
        totals: [],
        total_headings: '',
        seen: false,
        np_hidden: false,
        np_selected: [],
        selected: [],
        nationalPartners: [],
        restaurants: [],
        isLoading: false,
        fullPage: true,
        height: 128,
        width: 128,
        color: '#0647A6',
        loader: 'bars',
        include_cancelled: false,
        show_cancelled_only: false,
        isModalVisible: false
      }
    },
    computed: {
      isNPInvalid () {
        if(this.np_selected.length === 0)
          return true
      },
      isRestInvalid () {
        if(this.selected.length === 0)
          return true
      },
      isSupport () {
        if(userInfo.company == 'Support')
          return true
      },
      btnDissabled () {
        if(this.np_hidden) {
          if(this.selected.length === 0) {
            return true
          } else {
            return false
          }
        } else {
          if(this.selected.length === 0 || this.np_selected.length === 0) {
            return true
          } else {
            return false
          }
        }
      }
    },
    methods: {
      getInvoiceReport () {
        this.isLoading = true
        var startDate = moment(String(this.start_date)).format('YYYY-MM-DDTHH:mm:ss')
        var endDate = moment(String(this.end_date)).format('YYYY-MM-DDTHH:mm:ss')
        var self = this
        var extid = []
        var company = []
        self.table.title = ''
        self.table.columns = ''
        self.table.data = ''
        self.alert = ''
        self.totals = ''
        self.total_headings = ''
        self.seen = false

        // Restaurants
        if (this.selected.length > 0) {
          if(this.selected[0].externalId === 'selectAll') {
            for (let rest of Object.values(this.restaurants)) {
              if(rest.externalId !== 'selectAll') extid.push(rest.EXTIDs)
            }
          } else {
            for (let rest_sel of Object.values(this.selected)) {
              extid.push(rest_sel.EXTIDs)
            }
          }
        }
        // National Partners
        if(this.np_selected.length > 0) {
          if(userInfo.company != 'Support' && this.np_selected[0].CODE === 'selectAll') {
            company = userInfo.company
          }
          else if(userInfo.company == 'Support' || this.np_selected[0].CODE != 'selectAll') {
            for (let np_sel of Object.values(this.np_selected)) {
              company.push(np_sel.CODE)
            }
          }
          else {
            company = userInfo.company
          }
        } else {
          company = userInfo.company
        }

        API.post('/report/invoice_new', {
          np: company,
          extid: extid,
          include_cancelled: this.include_cancelled,
          show_cancelled_only: this.show_cancelled_only,
          interval: startDate + '/' + endDate
        })
        .then(function (response) {
          console.log('getInvoiceReport', response)
          if (response.data.status === 200) {
            self.alert = response.data.message
            self.table.title = 'Restaurant Invoice for '
            if(response.data.rv.totals.SHOW_ADJUSTMENTS) {
              self.table.columns = ['Store', 'City', 'Order', 'DSP', 'Date', 'Payment Method', 'Meal Period', 'Subtotal', 'DL % Comm', 'DL $ Comm', 'Food Payment', 'Tax', 'Adjustments', 'Net Pay']
            } else {
              self.table.columns = ['Store', 'City', 'Order', 'DSP', 'Date', 'Payment Method', 'Meal Period', 'Subtotal', 'DL % Comm', 'DL $ Comm', 'Food Payment', 'Tax', 'Net Pay']
            }
            self.table.data = response.data.rv.orders
            if(response.data.rv.totals.SHOW_ADJUSTMENTS) {
              self.total_headings = ['Total Orders', 'Subtotal', 'DL % Comm', 'DL $ Comm', 'Food Payment', 'Tax', 'Adjustments', 'Net Pay']
            } else {
              self.total_headings = ['Total Orders', 'Subtotal', 'DL % Comm', 'DL $ Comm', 'Food Payment', 'Tax', 'Net Pay']
            }
            self.totals = response.data.rv.totals
            self.seen = true
            self.isLoading = false
          } else {
            self.alert = response.data.message
            self.table.title = ''
            self.table.columns = ''
            self.total_headings = ''
            self.table.data = []
            self.totals = []
            self.seen = false
            self.isLoading = false
          }
        })
        .catch(function (error) {
          console.log(error)
          self.isLoading = false
          self.alert = 'Your request has timed out. Please refine your search and try again.'
        })
      },
      getRestaurants () {
        var self = this
        var company = []
        self.restaurants = []
        self.selected = []

        if(this.np_selected.length > 0) {
          if(userInfo.company != 'Support' && this.np_selected[0].CODE === 'selectAll') {
            company = userInfo.company
          }
          else if(userInfo.company == 'Support' || this.np_selected[0].CODE != 'selectAll') {
            for (let np_sel of Object.values(this.np_selected)) {
              company.push(np_sel.CODE)
            }
          }
          else {
            company = userInfo.company
          }
        } else {
          company = userInfo.company
        }

        self.restaurants = [{ externalId: 'selectAll', storeDisplay: 'All Restaurants' }]
        API.get('/restaurant/NP?np=' + company + '&role=' + userInfo.role + '&uid=' + userInfo.uid)
        .then(function (response) {
          if(response.data.entities) {
            for (let rest of Object.values(response.data.entities)) {
              self.restaurants.push(rest)
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      getNationalPartners () {
        var self = this
        //self.restaurants = [{ externalId: '', storeDisplay: 'Please select a partner first' }]
        if(userInfo.company != 'Support') self.nationalPartners = [{ CODE: 'selectAll', NAME: 'All Partners' }]
        API.get('/report/partners?np=' + userInfo.company)
        .then(function (response) {
          for (let np of Object.values(response.data.rv)) {
            self.nationalPartners.push(np)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      clearAllNP () {
        this.np_selected = []
      },
      clearAllRestos () {
        this.selected = []
      },
      showOrderModal (oid, np, extid, unix) {
        //console.log(this.$children[0])
        this.isModalVisible = true
        var input = []
        var self = this
        self.$children[0].order_items = []
        self.$children[0].totals = []
        self.$children[0].loading = true;
        if(oid) {
          API.post('/report/get_order_details', {
            oid, oid,
            np: np,
            extid: extid,
            unix: unix
          })
          .then(function (response) {
            //console.log(response)
            if (response.data.status === 200) {
              for (let item of Object.values(response.data.rv.order_data)) {
                self.$children[0].order_items.push(item)
                self.$children[0].store_info = {
                  NAME: item.NAME,
                  ADDRESS1: item.ADDRESS1,
                  CITY: item.CITY,
                  STATE: item.STATE,
                  ZIP: item.RZIP,
                }
              }
              self.$children[0].totals = response.data.rv.totals;
              self.$children[0].loading = false;
              console.log('showOrderModal', self)
            }
          })
          .catch(function (error) {
            console.log(error)
            self.$children[0].store_info = {
              NAME: "No Order Information Available.",
              ADDRESS1: '',
              CITY: '',
              STATE: '',
              ZIP: '',
            }
            self.$children[0].loading = false;
          })
        }
      },
      closeModal () {
        this.isModalVisible = false
      }
    },
    mounted () {
      var company = userInfo.company.split(',');
      if(company == 'Support' || company.length > 1) {
        this.getNationalPartners()
      }
      if(company != 'Support' && company.length == 1) {
        this.getRestaurants()
        this.$refs.partner_select.hidden = true
        this.np_hidden = true
      }
    }
  }
</script>
<style scoped>
th {
  padding-bottom: 10px !important;
}
#btn {
  width: 100%;
}
table>tbody>tr:last-child {
  font-weight: 600;
  background: #e3e3e3;
}
.totals-table {
  width: 70%;
  min-width: min-content;
  margin: 25px auto 35px;
  font-size: 16px;
  text-align: center;
  border: 1px solid #6f6f6f;
}
.totals-table.table > tbody > tr > td,
.totals-table.table > thead > tr > th {
  padding: 12px;
}
.totals-table th {
  font-size: 16px;
  text-align: center;
}
.total-header {

}
.Commission-Adjustments,
.small_width {
  width: 30px;
}
.red {
  color: red;
}
/* @media (max-width: 1400px) {
  .totals-table {
    width: 95%;
  }
} */
@media (max-width: 991px) {
  .totals-table, .totals-table th {
    font-size: 14px;
  }
  .card .restaurant-table.table thead th:first-child {
    padding-left: 0;
  }
  /* .totals-table {
    width: 95%;
  } */
}
</style>



// WEBPACK FOOTER //
// Invoice.vue?8fefe778